"use client";

import LoginCollection from "@components/User/LoginCollection";
import { parentRedirect } from "@hudson/ui/lib/utils";
import FrameConfig from "@lib/classes/FrameConfig";
import { NextPage } from "next";
import { useRouter, useSearchParams } from "next/navigation";

const LoginPage: NextPage = ({}) => {
  const router = useRouter();
  const searchParams = useSearchParams();
  const nextPage = searchParams?.get("nextPage");

  const frameConfig = new FrameConfig();
  let onLoginOrCreate;
  if (nextPage) {
    onLoginOrCreate = () => router.replace(`/${window.siteId}/${nextPage}`);
  } else if (frameConfig.bookingUrl) {
    onLoginOrCreate = () => parentRedirect(frameConfig.bookingUrl as string);
  } else {
    onLoginOrCreate = () => router.replace(`/${window.siteId}/book`);
  }

  return (
    <div className="-mt-14">
      <LoginCollection hideCreate={false} onLoginOrCreate={onLoginOrCreate} />
    </div>
  );
};

export default LoginPage;
